import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-20" data-mp="pjpx9t6ljn8q">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-21" data-mp="pm2eg44j5tkq">
        <div className="text-center" data-id="element-22" data-mp="aua6weaz9jtk">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-23" data-mp="at8v27m50tas">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-24" data-mp="1u5a0y3eu3tn">
            Five instant-use <span className="text-gold" data-id="element-25" data-mp="3o1lgyw505tlk">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-26" data-mp="3o3fz62ow37ly">
            The volumes give you the season. These five turn it into something
            you can use before your next practice.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-27" data-mp="1r9bk80eba81p">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-28" data-mp="3ieg5kyb27wy7" data-mpi={i}>
              <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="h-[230px] w-full border-b border-navy-line object-cover sm:h-[265px]" data-id="element-29" data-mp="3n4wmise3a0pb" />
              <div className="px-5 pb-6 pt-4" data-id="element-30" data-mp="38giiie4xs676">
                <div className="flex flex-wrap items-center gap-2" data-id="element-31" data-mp="38e5ubj8l4zlo">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-32" data-mp="33ge54wzbrrl6">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-33" data-mp="irg9evb18b1v">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-34" data-mp="3hhhr0o0cu172">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-35" data-mp="3lk4de9e9atwv">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}